import { number, object, string } from "yup"
import { MINIMUM_AGE } from "../../customer"
import { maxAge, minAge } from "../yup/birth-date"
import { dateISOString } from "../yup/date-iso-string"
import { addressSchema } from "./address"
import { emailSchema } from "./email"
import { buildSchema } from "./util/build-schema"

const MAX_AGE = 120
export const MIN_SHARE = 1
export const MAX_SHARE = 100

const schema = object({
  firstName: string().required(),
  middleName: string(),
  lastName: string().required(),
  email: emailSchema.required(),
  birthDate: dateISOString()
    .required()
    .test(minAge(MINIMUM_AGE))
    .test(maxAge(MAX_AGE)),
  taxNumber: string(),
  ownershipPercent: number().required().min(MIN_SHARE).max(MAX_SHARE),
  address: addressSchema.required(),
})

export const entityBeneficialOwnerSchema = buildSchema(
  "EntityBeneficialOwner",
  schema
)
